import Quill from 'quill';

const EmbedBlot = Quill.import('blots/embed') as any;

class CursorPlaceholderBlot extends EmbedBlot {
    static blotName = 'cursorPlaceholder';
    static tagName = 'SPAN';
    static className = 'ql-merge-field';

    static create(value: string): HTMLElement {
        const node = super.create() as HTMLElement;
        node.setAttribute('data-value', value);
        node.textContent = value;
        node.contentEditable = 'false';
        return node;
    }

    static value(domNode: HTMLElement): string {
        return domNode.getAttribute('data-value') ?? domNode.textContent ?? '';
    }
}

Quill.register({ 'formats/cursorPlaceholder': CursorPlaceholderBlot }, true);
